






















import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class ExploreSidebar extends Vue {
  @Prop({default: ''})
  category: string = ''
  @Prop({default: ''})
  group: string = ''

  @Prop({ default: {} })
  groups: any

  len(x: object) { return Object.keys(x).length }

  go(group: string, cat: string) {
    this.category = cat
    this.group = group
    this.$emit('update:group', group)
    this.$emit('update:category', cat)
  }

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/explore-sidebar.vue